export default __webpack_public_path__ + "static/media/hexomatic-logo-rectangle.d3bde2c9.svg";